import { Settings } from "lucide-react"
import type { NotificationRenderer } from "../../types"
import { navigateForAction } from "../actionRoutes"

// Icon mirrors the sidebar's settings entry (IconSettings, links to /settings
// same as this notification's open_usage action).
// Payload is untrusted: type-guard before using a field as a param.
export const creditsLow: NotificationRenderer = {
  icon: Settings,
  accent: "warning",
  title: (payload) =>
    typeof payload?.threshold === "number"
      ? { key: "NOTIF/CREDITS_LOW/TITLE", params: { threshold: payload.threshold } }
      : { key: "NOTIF/CREDITS_LOW/TITLE_GENERIC" },
  description: () => ({ key: "NOTIF/CREDITS_LOW/DESC" }),
  cta: "NOTIF/CTA/VIEW_USAGE",
  onAction: navigateForAction,
}
